import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class DriverFareCalculation extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  fareCalculationId: number;

  @autoserialize
  fareReviewStatus: string;

  @autoserialize
  active: boolean;

  @autoserialize
  estimate: boolean;

  @autoserialize
  adjustedByUser: string;

  @autoserialize
  reviewedByUser: string;

  @autoserialize
  distanceMiles: number;

  @autoserialize
  durationSeconds: number;

  @autoserialize
  minimumFare: number;

  @autoserialize
  providerDistanceRate: number;

  @autoserialize
  providerTimeRate: number;

  @autoserialize
  providerBaseFare: number;

  @autoserialize
  providerDistanceFare: number;

  @autoserialize
  providerTimeFare: number;

  @autoserialize
  providerIncentive: number;

  @autoserialize
  providerInvoiceAmount: number;

  @autoserialize
  tollReimbursement: number;

  @autoserialize
  totalProviderCommission: number;

  @autoserializeAs(Date)
  reviewedAt: Date;

  durationInMinutes: number;

  static OnSerialized(instance: DriverFareCalculation, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.reviewedAt)) {
      json.reviewedAt = DateUtil.serializeDate(instance.reviewedAt);
    }

    if (!isNullOrUndefined(instance.durationInMinutes)) {
      json.durationSeconds = instance.durationInMinutes * 60;
    }
  }

  static OnDeserialized(instance: DriverFareCalculation, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['reviewedAt'])) {
      instance.reviewedAt = DateUtil.deserializeDate(json['reviewedAt']);
    }

    if (!isNullOrUndefined(json['durationSeconds'])) {
      instance.durationInMinutes = +(instance.durationSeconds / 60).toFixed(2);
    }
  }
}
